

























import {Component, Vue} from "vue-property-decorator";
import {getPublicPath} from "@/shared/services/helper/utils";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import EnumLabel from "@/shared/components/EnumSelector/components/Label.vue";
import {PickingListTranshipmentParams, PickingListTranshipmentStore} from "@/modules/pickinglisttranshipment";
import PLTranshipmentTable
  from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentTable/index.vue";
import PLTranshipmentDetail
  from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentDetail/index.vue";
import PLTranshipmentPrint
  from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentPrint/index.vue";
import PLTranshipmentSearch
  from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentSearch/index.vue";
import {PickingListDeliveryStore} from "@/modules/pickinglistdeliveries";

@Component({
  name: "StockOutTranshipment",
  components: {
    PLTranshipmentSearch,
    PLTranshipmentPrint,
    PLTranshipmentDetail,
    PLTranshipmentTable,
    EnumLabel
  }
})
export default class extends mixins(CommonMixin) {
  visible = false;
  id = null;
  printObj = {
    id: "picking-list-transhipments-print",
    popTitle: 'Logistic',
    extraCss: `${getPublicPath()}assets/css/print.css`,
  };

  created() {
    PickingListTranshipmentStore.updatePickingListTranshipmentParams({...new PickingListTranshipmentParams()});
    PickingListTranshipmentStore.listPickingListTranshipment(PickingListTranshipmentStore.params);
  }

  get pickingListTranshipments() {
    return PickingListTranshipmentStore.ids.map((id: number) => PickingListTranshipmentStore.data[id]);
  }

  onChangePage(pagination) {
    PickingListTranshipmentStore.listPickingListTranshipment({
      ...PickingListTranshipmentStore.params,
      page: pagination.current,
      limit: pagination.pageSize
    })
  }

  async seeDetail(id: number) {
    if (isNaN(id)) return;
    this.id = id as any;
    await PickingListTranshipmentStore.listBillLadingByPickingListTranshipment(this.id);
    this.visible = true;
  }

  async print(id: number) {
    if (isNaN(id)) return;
    this.id = id as any;
    await PickingListTranshipmentStore.listBillLadingByPickingListTranshipment(this.id);
    this.$print(this.printObj);
  }

  async deletePickingListTranshipment(id: number) {
    if (isNaN(id)) return;
    try {
      await PickingListTranshipmentStore.deletePickingListTranshipment(id);
      this.$message.success("Xóa bảng kê thành công");
    } catch (e) {
      this.$message.error(e?.response?.data?.message || 'Xóa bảng kê thất bại');
    }
  }

  async confirmPickingListTranshipment(id: number) {
    if (isNaN(id)) return;
    try {
      await PickingListTranshipmentStore.confirmPickingListTranshipment(id);
      this.$message.success("Xác nhận bảng kê thành công");
    } catch (e) {
      this.$message.error(e?.response?.data?.message || 'Xác nhận bảng kê thất bại');
    }
  }

  createTranshipment() {
    this.$router.push({name: "createTranshipment"});
  }
}
